module.exports = __webpack_public_path__ + "img/img-movietag.8101926b.png";